<script>
    import{ createForm } from "svelte-forms-lib";
    import * as yup from "yup";
    import { sendToken } from "../../services/subscribersService";
    import toast from "svelte-french-toast";
    import { navigate } from "svelte-routing";
    import InputField from "../../components/Forms/InputField.svelte";
    import ButtonPromise from "../../components/Button/ButtonPromise.svelte";

    let tokenRequestPromise = null;

    const { form, handleChange, errors, isValid, validateField } = createForm({
        initialValues: { email: "" },
        validationSchema: yup.object().shape({
            email: yup.string().email("Inserisci una mail corretta").required("Inserisci una e-mail")
        })
    });

    async function handleEmailSubmit() {
        await validateField("email");

        if (!$isValid) {
            return;
        }

        tokenRequestPromise = (async () => {
            try {
                await sendToken($form.email , "access_registration_multi");

                toast.success(
                    "La mail con il link per registrare altri iscritti è stata mandata alla sua casella postale.",
                    {duration: 8000}
                );
                navigate("/", {replace: true});
            } catch (e) {
                toast.error("Non è stato possibile inviare la mail, riprovi più tardi");
            } finally {
                tokenRequestPromise = null;
            }
        })();
    }

</script>

<div class="min-h-600-px flex justify-center w-full">
    <div class="flex flex-col content-color items-center select-none gap-6 h-full w-full md:w-8/12 xl:w-4/12">
        <div class="text-2xl mt-4">
            Dopo l'attivazione della tua iscrizione, inserisci la tua mail e registra i nuovi aderenti cliccando sul link che arriverà sulla tua casella di posta
        </div>

        <form class="w-full flex flex-col gap-1">
            <div class="text-xl">Inserisci la tua email</div>

            <div class="flex flex-col gap-3">
                <InputField
                    placeholder="Email"
                    name="email"
                    bind:errorText={$errors.email}
                    bind:value={$form.email}
                    handleChange={handleChange}
                />

                <ButtonPromise
                    handleClick="{() => handleEmailSubmit()}"
                    promise="{tokenRequestPromise}"
                    content="Inserisci la mail"
                    buttonClass="bg-lb w-64 h-9 text-center rounded text-lg py-1"
                />
            </div>
        </form>
    </div>
</div>